require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-when-health-meets-wealth.json") })
        }
      }, "path---articles-when-health-meets-wealth");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-when-health-meets-wealth!./.cache/json/articles-when-health-meets-wealth.json
// module id = 1929
// module chunks = 231608221292675